/**
 * IMPORTS
 */

import { enderecosRepository } from "@/repositories/enderecos";

/**
 * Função que busca os endereços de usuário 🛠️.
 */
const handleBuscarEnderecosSeparadosPorTipo = async (accessToken: string, user_id: number) => {
  try {
    const data = await enderecosRepository.buscarEnderecosSeparadosPorTipo(accessToken, user_id);

    return data;
  } catch (error: any) {
    console.log("ERROR AO BUSCAR ENDEREÇOS POR TIPO: ", error);

    return error;
  }
};

/**
 * EXPORTS
 */
export { handleBuscarEnderecosSeparadosPorTipo };
